export default __webpack_public_path__ + "static/media/femme&cinema.f5ac0507.jpeg";